/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Empty_UnreadInputs */

const en_notifications_empty_unread = /** @type {(inputs: Notifications_Empty_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're all caught up.`)
};

const pt_br2_notifications_empty_unread = /** @type {(inputs: Notifications_Empty_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está em dia.`)
};

/**
* | output |
* | --- |
* | "You're all caught up." |
*
* @param {Notifications_Empty_UnreadInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_empty_unread = /** @type {((inputs?: Notifications_Empty_UnreadInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Empty_UnreadInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_empty_unread(inputs)
	return pt_br2_notifications_empty_unread(inputs)
});